<template>
    <DModal
        is-confirm
        is-error
        :is-awaiting-validation="true"
        :title="__('tools.fulfillment.request_details')"
        :show="showModal || modalHasErrors"
        @close="closeModal"
        @confirm="confirm"
        @clearFields="resetMarkAsDoneForm()"
    >
        <div style="padding: 15px;">
            <DFormRow
                :label="getLabel"
                :is-required="true"
                :error="errors.external_id"
                :hint="getHint"
            >
                <DInput
                    id="external_id"
                    v-model="requestData.job_reference.external_id"
                    :is-valid="typeof errors.external_id === 'undefined' ? null : false"
                    maxlength="255"
                    @input="updateExternalId"
                />
            </DFormRow>
            <DFormRow
                :label="__('tools.fulfillment.fulfillment_account')"
                :is-required="true"
                :error="errors.fulfillment_account_id"
            >
                <DSelect
                    id="fulfillment_account"
                    v-model="requestData.fulfillment_account_id"
                    :options="fulfillmentAccountOptions"
                    selection-type="text"
                />
            </DFormRow>
            <DFormRow
                v-for="(row, index) in requestData.instance_settings"
                :key="index"
                :label="row.name"
                :is-required="true"
                :error="getErrorMessage(row)"
            >
                <DSwitch
                    v-if="row.type === 'bool'"
                    :id="`option_${row.name}`"
                    v-model="requestData.instance_settings[row.name].value"
                    color="success"
                    variant="3d"
                    :class="{'is-invalid': !!errors[`instance_settings.${row.name}.value`]}"
                    :description="row.description"
                />
                <DInput
                    v-if="['string', 'integer', 'email', 'array'].includes(row.type)"
                    :id="`option_${row.name}`"
                    v-model="requestData.instance_settings[row.name].value"
                    :is-valid="typeof errors[`instance_settings.${row.name}.value`] === 'undefined' ? null : false"
                    :description="row.description"
                />
                <DFormTextarea
                    v-if="row.type === 'text'"
                    :id="`option_${row.name}`"
                    v-model="requestData.instance_settings[row.name].value"
                    :is-valid="typeof errors[`instance_settings.${row.name}.value`] === 'undefined' ? null : false"
                    :description="row.description !== null ? row.description : __('messages.select_value')"
                    rows="8"
                />
                <DSelect
                    v-if="row.type === 'list'"
                    :id="`option_${row.name}`"
                    v-model="requestData.instance_settings[row.name].value"
                    :options="row.options"
                    :is-valid="typeof errors[`instance_settings.${row.name}.value`] === 'undefined' ? null : false"
                    :description="row.description"
                    :placeholder="row.description"
                />
            </DFormRow>
        </div>
    </DModal>
</template>

<script>
export default {
    name: 'MarkRequestDoneModal',
    props: {
        request: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        externalIdMapping: {
            type: Object,
            default: () => { return {} }
        },
        filter: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal'],
    data () {
        return {
            externalId: this.request.job_reference.external_id,
            modalHasErrors: false,
            errors: {},
            requestData: { ...this.request, fulfillment_account_id: this.request.job_reference.fulfillment_account_id }
        }
    },
    computed: {
        fulfillmentAccountOptions () {
            return this.request.available_fulfillment_accounts.map((acc) => ({
                label: acc.name,
                value: acc.id
            }))
        },
        getLabel () {
            const langKey = 'tools.contract.name.' + this.requestData.filter
            const langText = this.__(langKey)
            if (langKey !== langText) {
                return langText
            }
            return this.__('tools.contract.name.anyOtherModule')
        },
        getHint () {
            const modName = this.requestData.filter
            const hint = (modName in this.externalIdMapping) ? this.externalIdMapping[modName].hint : this.externalIdMapping.anyOtherModule.hint
            if (hint === '') {
                return ''
            }
            return this.__('tools.contract.hintIntro') + ' ' + hint
        }
    },
    created () {
        if (this.requestData.fulfillment_account_id === null) {
            this.requestData.fulfillment_account_id = this.fulfillmentAccountOptions[0]?.value
        }
    },
    methods: {
        closeModal () {
            this.$emit('close-modal')

            this.errors = {}
        },
        confirm () {
            this.$inertia.post(this.$route('tools.fulfillment.markAsDone', {
                jobRequest: this.requestData.id,
                _query: this.filter
            }), {
                action: this.requestData.action.name,
                external_id: this.requestData.job_reference.external_id,
                contract_id: this.requestData.job_reference.id,
                fulfillment_account_id: this.requestData.fulfillment_account_id,
                instance_settings: this.requestData.instance_settings
            }, {
                onSuccess: () => {
                    this.$emit('close-modal')
                    this.resetMarkAsDoneForm()
                    this.modalHasErrors = false
                },
                onError: (error) => {
                    this.errors = error
                    this.modalHasErrors = true
                }
            })
        },
        updateExternalId (id) {
            this.externalId = id
        },
        resetMarkAsDoneForm () {
            this.requestData.external_id = null
            this.requestData.fulfillment_account_id = null
            this.errors = {}
        },
        getErrorMessage (row) {
            if (!this.errors[`instance_settings.${row.name}.value`]) {
                return this.errors[`instance_settings.${row.name}.value`]
            }

            return this.errors[`instance_settings.${row.name}.value`].replaceAll('instance settings.', '').replaceAll('.value', '')
        }
    }
}
</script>
